import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual"; // stop browser restoring old position
    }
    // Instant scroll to top
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
